export default function gaFilterListShortName({filter = {}, s: sortFn = '', isSEO = false}) {
  let listName = '';
  if (isSEO) {
    listName += 'S';
  } else {
    listName += 'D';
  }

  const {tag = '', tags = [], ...otherFilters} = filter;

  if (tag) listName += `_${tag.charAt(0).toUpperCase()}`;
  else if (tags && tags.length) listName += `_${tags[0].charAt(0).toUpperCase()}`;
  else listName += '_H';

  switch (sortFn) {
    case 'popularity':
      listName += '_Po';
      break;

    case 'pricedown':
    case 'priceup':
      listName += '_Pr';
      break;

    case 'rating':
      listName += '_R';
      break;

    case 'nearby':
      listName += '_Ne';
      break;

    default:
      listName += '_Po';
  }

  let applied = 0;
  Object.keys(otherFilters).forEach(fltkey => {
    const flt = otherFilters[fltkey];
    if (Array.isArray(flt) && flt.length > 0) {
      applied += 1;
    } else if (typeof flt === 'string' && flt.length) {
      applied += 1;
    } else if (typeof flt === 'number' && flt > 0) {
      applied += 1;
    }
  });

  if (applied > 0) {
    let filterString = '';
    const {
      step_range,
      star,
      location_search,
      landmark,
      transit,
      type,
      amenities,
      fc,
      rnpl,
      pah,
      gobiz,
      cf,
      fbfi,
      chain,
    } = otherFilters;
    if (amenities && amenities.length) filterString += 'A,';

    if (fc) filterString += 'FC,';

    if (
      (location_search && location_search.length) ||
      (landmark && landmark.length) ||
      (transit && transit.length)
    )
      filterString += 'L,';

    if (step_range && step_range.length) filterString += 'P,';

    if (star && star.length) filterString += 'S,';

    if (type && type.length) filterString += 'T,';

    if (chain && chain.length) filterString += 'C,';
    if (cf) filterString += 'CF,';

    if (rnpl) filterString += 'RN,';

    if (pah) filterString += 'PAH,';

    if (fbfi) filterString += 'FB,';

    if (gobiz) filterString += 'BIZ,';

    if (filterString && filterString.charAt(filterString.length - 1) === ',') {
      filterString = filterString.slice(0, -1);
    }

    if (filterString) listName += '_F_<' + filterString + '>';
  }

  return listName;
}
